import { useSession } from '../context/SessionContext';
import { getPendingAction } from '../lib/pendingActions';

export function GuestGate({
  open,
  onDismiss,
}: {
  open: boolean;
  onDismiss: () => void;
}) {
  const { startKeyra } = useSession();
  if (!open) return null;

  const pending = getPendingAction();

  return (
    <div className="gate" role="dialog" aria-modal="true" aria-labelledby="gate-title">
      <div className="gate-card">
        <h2 id="gate-title">Keep exploring in 3D</h2>
        <p className="muted">
          Create your account to view more objects, save collections, follow creators, and publish
          your own work.
        </p>
        <div className="row" style={{ marginTop: '1rem' }}>
          <button
            type="button"
            className="btn primary"
            onClick={() => void startKeyra(pending ?? undefined)}
          >
            Continue with Keyra
          </button>
          <button type="button" className="btn" onClick={onDismiss}>
            Back to feed
          </button>
        </div>
      </div>
    </div>
  );
}
